import { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate, updateTextFields } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Input, ConfirmButtons, Table, Card } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import useStateWithPromise from '../../../../utils/useEffectUpdate';
import SelectMaritimeCompany from '../../../../components/UI/SelectMaritimeCompany';
import SelectNew from '../../../../components/UI/SelectNew';

const AviexpUpdate = (props) => {
    const [aviexp, setAviexp] = useStateWithPromise();

    useEffect(() => {
        setAviexp({ ...props.data }).then(() => {
            updateTextFields();
        })
        // eslint-disable-next-line
    }, [props.data]);

    const onChange = (event) => {
        onValueChange(event, aviexp, setAviexp);
    };

    const itemSpawning = (item) => {
        return item.containerItem.filter(f => f.spawning).length > 0
    }

    const onConfirm = () => {
        if (validateInputsRequired('updateAviexp')) {
            props.associeteContainerAviexp(aviexp, () => {
                props.closeModal()
            })
        }
    }

    const onChangeItem = (evt) => {
        var id = evt.currentTarget.id ? evt.currentTarget.id.split('-')[1] : '';
        var item = aviexp.aviexpPartNumber.find(f => f.id === parseInt(id))

        if (item) {
            item.packaging = evt.currentTarget?.value;

            setAviexp({ ...aviexp })
        }
    }

    const configColumn = () => {
        const cols = [
            {
                field: 'partNumber',
                header: 'PartNumber',
                align: 'left',
                sortable: false
            },
            {
                field: 'spawning',
                header: 'Pago',
                align: 'left',
                body: (rowData) => {
                    return itemSpawning(rowData) ? "SIM" : 'Não'
                },
                sortable: false
            },
            {
                field: 'packaging',
                header: 'Packaging',
                body: (rowData) => {
                    return <div className="input-field no-padding col s6">
                        <Input
                            disabled={itemSpawning(rowData)}
                            id={`Packaging-${rowData.id}`}
                            name='capacity'
                            label='Packaging'
                            required={!itemSpawning(rowData)}
                            value={rowData?.packaging || ''}
                            onChange={(evt) => onChangeItem(evt)}
                        />
                    </div>
                },
                align: 'left',
                sortable: false
            },
            {
                field: 'boxQuantity',
                header: translate('container:fields:items:boxQuantity'),
                align: 'left',
                sortable: false
            }
        ];
        return cols;
    };


    return (
        <div className="container-fluid" style={{ marginTop: '25px', }}>
            <div className="container">
                <form id="updateAviexp" className="col s12">
                    <span className="title col s12">{"Editar Aviexp"}</span>
                    <Card>
                        <div className="row" style={{ padding: '10px' }}>
                            <div className="input-field no-padding col s5">
                                <Input
                                    disabled={aviexp?.containerAssociation}
                                    id="container"
                                    name='container'
                                    label="Container"
                                    type="text"
                                    value={aviexp?.container || ''}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="input-field no-padding col s5">
                                <SelectMaritimeCompany
                                    required
                                    name="maritimeCompany"
                                    id="maritimeCompany"
                                    focus="true"
                                    defaultValue={aviexp?.maritimeCompanyId}
                                    value={aviexp?.maritimeCompanyId || ""}
                                    onChange={onChange} />
                            </div>
                            <div className="input-field no-padding col s5">
                                <Input
                                    id="originCountry"
                                    name='originCountry'
                                    label="Porto Origem"
                                    type="text"
                                    value={aviexp?.originCountry || ''}
                                    onChange={onChange}
                                />
                            </div>

                            <div className="input-field no-padding col s5">
                                <Input
                                    id="remorque"
                                    name='remorque'
                                    label="Remorque"
                                    type="text"
                                    value={aviexp?.dischargePortCode || ''}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="input-field no-padding col s5">
                                <SelectNew
                                    id="unloadLocationId"
                                    name="unloadLocationId"
                                    placeHolder={translate('choose-one-option', 'general')}
                                    label={translate('fields.unloadLocation', 'container')}
                                    data={props.unloadLocations?.map((x) => ({ id: x.id, text: `${x.code} - ${x.description}` }))}
                                    change={onChange}
                                    value={aviexp?.unloadLocationId || ""}
                                />
                            </div>
                        </div>
                    </Card>
                    <div className="row" style={{ marginBottom: '5px' }}>
                        <span className="title col s12">{"Editar Packaging"}</span>
                        <div className="input-field no-padding col s12 container-fluid">
                            <Table
                                col={configColumn()}
                                data={aviexp?.aviexpPartNumber || []}
                                disablePaged
                            />
                        </div>
                    </div>
                </form>
                <ConfirmButtons
                    onConfirm={onConfirm}
                    onCancel={() => {
                        props.closeModal()
                    }} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        unloadLocations: state.containerReducer.unloadLocationList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        associeteContainerAviexp: (data, callback) => {
            dispatch(ContainerService.updateAviexp(data, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AviexpUpdate));
